/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 14:57:23
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-14 12:29:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/slice/index.ts
 */
import { combineReducers } from '@reduxjs/toolkit';
import storeProductVirtual from '../VirtualProduct/slice';
const salesChannelLegalReducer = combineReducers({
  virtualProduct: storeProductVirtual,
});
export default salesChannelLegalReducer;
export { EnumReducers } from './constants';
